export const faq = [
  {
    q: "Quelles zones couvrez-vous autour de Vichy ?",
    a: "Nous intervenons à Vichy (03200) et dans un rayon d'environ 30 km : Cusset, Bellerive-sur-Allier, Abrest, Creuzier-le-Vieux, Saint-Yorre, Hauterive, Le Vernet, Charmeil, Saint-Germain-des-Fossés et les communes voisines de l'Allier.",
  },
  {
    q: "Combien coûte un agent d'entretien à Vichy ?",
    a: "Chaque prestation est chiffrée sur mesure : il n'y a pas de barème fixe car le résultat dépend de la surface, de la fréquence, du niveau d'exigence et des contraintes d'accès. Nous établissons un devis gratuit et détaillé sous 48 h après une visite ou un échange téléphonique.",
  },
  {
    q: "Travaillez-vous en dehors des heures d'ouverture ?",
    a: "Oui, nous privilégions les interventions tôt le matin, en soirée ou le week-end pour ne pas perturber votre activité, aussi bien pour les bureaux que pour les commerces.",
  },
  {
    q: "Quels types de contrats proposez-vous ?",
    a: "Contrats réguliers (quotidien, hebdomadaire, bi-mensuel, mensuel) ou prestations ponctuelles (fin de chantier, grand ménage, vitres). Les contrats sont résiliables selon les conditions prévues dans le devis.",
  },
  {
    q: "Gérez-vous le ménage des Airbnb et locations saisonnières ?",
    a: "Oui, le nettoyage de locations courtes durées (Airbnb, Booking, Abritel, gîtes) est l'une de nos spécialités à Vichy. Nous respectons les créneaux check-out / check-in (souvent 11h-15h), assurons le changement du linge, le réassort des consommables et envoyons un check photos à l'hôte après chaque passage. Disponibles 7j/7 pendant la saison.",
  },
  {
    q: "Utilisez-vous des produits écologiques ?",
    a: "Oui. Sur demande, nous utilisons des produits écolabellisés et des microfibres, qui limitent l'usage de détergents tout en garantissant un haut niveau d'hygiène.",
  },
  {
    q: "Pouvez-vous fournir les consommables (papier, savon, sacs) ?",
    a: "Oui, nous pouvons gérer l'ensemble des consommables sanitaires avec un suivi et un réassort programmé.",
  },
];
